export const TOGGLE_MENU = 'TOGGLE_MENU';
export const FORM_TYPE = 'FORM_TYPE';
export const FORM_NAME = 'FORM_NAME';
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SUBMIT_ERROR = 'SUBMIT_ERROR';
